/**
 * Point d'entrée du package partagé.
 *
 * Consommé tel quel (sources TypeScript) par les deux applications :
 * Vite l'alias directement, esbuild le bundle pour le serveur.
 * Aucun artefact de build intermédiaire à maintenir.
 */

export * from './constants.js';
export * from './ids.js';
export * from './protocol.js';
export * from './types.js';
export * from './wire.js';

/**
 * Formate un nombre d'octets en une chaîne lisible.
 * Utilisé par l'UI et les logs ; vit ici pour garantir un affichage cohérent partout.
 */
export function formatBytes(bytes: number, decimals = 1): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 o';
  const units = ['o', 'Ko', 'Mo', 'Go', 'To'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exponent;
  const unit = units[exponent] ?? 'o';
  return `${value.toFixed(exponent === 0 ? 0 : decimals)} ${unit}`;
}

/** Formate un débit en octets par seconde. */
export function formatSpeed(bytesPerSecond: number): string {
  if (!Number.isFinite(bytesPerSecond) || bytesPerSecond <= 0) return '—';
  return `${formatBytes(bytesPerSecond, 1)}/s`;
}

/** Formate une durée en secondes vers `1 h 04 min` / `2 min 30 s` / `12 s`. */
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '—';
  const total = Math.round(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  if (hours > 0) return `${hours} h ${String(minutes).padStart(2, '0')} min`;
  if (minutes > 0) return `${minutes} min ${String(secs).padStart(2, '0')} s`;
  return `${secs} s`;
}
